import HiddenInput from "@/components/form/components/HiddenInput";
import { datePickerFormItemProps, datePickerStandardProps } from "@/utils/componentUtils";
import { setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { DatePicker, Form, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateCommissionsBatchFinishedDate } from "../../../../../common/api/queries";
import { CommissionsBatch, UpdateCommissionsBatchFinishedDate } from "../../types";
import { convertCommissionsBatchToCommissionsBatchFinishedDate } from "../../utils";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  batch: CommissionsBatch;
};

export const CommissionBatchFinishedDateFormModal = ({ isOpen, onClose, batch }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<UpdateCommissionsBatchFinishedDate>();

  const updateCommissionsBatchFinishedDate = useUpdateCommissionsBatchFinishedDate();

  useEffect(() => {
    if (isOpen) {
      const formData = convertCommissionsBatchToCommissionsBatchFinishedDate(batch);

      form.setFieldsValue(formData);
    }
  }, [isOpen, form]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      updateCommissionsBatchFinishedDate.mutate(
        {
          id: batch.id,
          object: values,
        },
        { onSuccess: onClose, onError: (error) => setErrorsToForm(form, "commissions.batch.attrs", error.violations) },
      );
    });
  };

  return (
    <Modal
      title={t("commissions.batch.titles.updateBatch")}
      open={isOpen}
      onCancel={onClose}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      onOk={handleSubmit}
      afterClose={() => form.resetFields()}
    >
      <Form form={form} layout="vertical" name="updateCommissionsBatchFinishedDate">
        <HiddenInput name="optimisticLockVersion" />

        <Form.Item
          name="finishedDate"
          label={t("commissions.batch.attrs.finishedAt")}
          rules={[validations.notNull]}
          {...datePickerFormItemProps}
        >
          <DatePicker {...datePickerStandardProps} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
